import React from "react";
import { Modal, ProgressBar } from "react-bootstrap";

const DownloadProgressModal = ({ show, progress = 0, status = "" }) => {
    const displayProgress = Math.round(progress);
    const displayStatus = status || "Preparing download...";

    return (
    <Modal
        show={show}
        centered
        size="sm"
        backdrop="static"
        keyboard={false}
        className="vl-download-modal"
        backdropClassName="vl-download-backdrop"
    >
        <Modal.Body className="p-3">
            <style>{`
                .vl-download-title-row {
                    color: #198754;
                    font-size: 0.95rem;
                    font-weight: 600;
                }
                .vl-download-status {
                    min-width: 0;
                }
                .vl-download-backdrop { z-index: 1990 !important; }
                .vl-download-modal { z-index: 2000 !important; }
            `}</style>
            <div className="vl-download-title-row d-flex align-items-center justify-content-between gap-3 mb-3">
                <div className="vl-download-status text-truncate">{displayStatus}</div>
                <div className="flex-shrink-0 text-end">{displayProgress}%</div>
            </div>
            <ProgressBar now={progress} variant="success" animated={progress > 0 && progress < 100} />
        </Modal.Body>
    </Modal>
    );
};

export default DownloadProgressModal;
